/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import './booking.scss';
import { useLazyQuery, useQuery } from '@apollo/client';
import { useParams, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import DialogPanel from '../dialog-panel/dialog-panel';
import DialogPanelBody from '../dialog-panel/dialog-panel-body/dialog-panel-body';
import {
  ConfirmEntitiesIcon,
  AddForwarderIcon,
  BookingDetailsIcon,
  NextIcon,
  PrevIcon,
  ShipmentIcon,
  ProductDetailsIcon,
  SelectProductIcon,
} from '../icons/icons';
import Button from '../button/button';
import PanelCard from '../panel-card/panel-card';
import ConfirmEntity from '../add-order-lines/confirmEntity';
import {
  FETCH_BOOKING,
  FETCH_CONSOLE_BULK_BOOKING,
  WAREHOUSE_LIST,
} from '../../graphQL/saveBooking';
import { giveProfile } from '../global-notification/notification-list';
import GlobalLoader from '../global-loader/global-loader';
import {
  CreateBookingCompletedIcon,
  CreateBookingCurrentIcon,
  CreateBookingPendingIcon,
  CreateBookingWarningIcon,
  CreateBookingDisabledIcon,
} from '../icons/create-booking';
import BookingDetailsTab from './buyer-booking-tabs/bookingDetails';
import ShipmentDetailsTab from './buyer-booking-tabs/shipmentDetails';
import AddForwarderTab from './buyer-booking-tabs/addForwarder';
import {
  defaultDeliveryValues,
  defaultDestinationValues,
  defaultOriginValue,
  defaultPickUpValues,
  findDefaultDeliveryAddress,
  findDefaultPickUpAddress,
  findNotifyPartyAndConsignee,
  getBookingValue,
  getPartiallyBooked,
  handleDeliveryPickup,
  handlePrimaryDelivery,
  handlePrimaryPickup,
  handlePrimaryPickupDeliveryBooking,
  handleSingleBookingType,
} from './buyer-booking-tabs/buyerHelper';
import useDialog from '../dialog/useDialog';
import ProductDetailsTab from './buyer-booking-tabs/productDetails';
import PackagingDetailsTab from './buyer-booking-tabs/packagingDetails';
import ConsolidatedPkgDetailsTab from './buyer-booking-tabs/consolidatedPkgDetails';
import { MATERIAL_LIST } from '../../graphQL/myCustoms';
import { PACKAGE_LIST } from '../../graphQL/createBooking';
// import usePermissionTabs from '../../tabmanagement/CentralizedPermissions';
import { consolidationSelectionList } from '../../graphQL/my-console';
import { buyerBookingConsole } from '../../schema/bookingColumns';
import ConsoleBooking from './console-booking';

function BuyerBooking({
  columns,
  itemsData,
  toggleViewDetailsModal,
  isBulk,
  refetchOrderDetails,
  consigneeId,
  refetchRfqList,
  customIdsBooking,
  customIds,
  refetchConsolidatedList,
  isConsole,
  modeSelectionConsole,
  bulkVitroRefIds,
}) {
  const [t] = useTranslation('manageorders');
  const [t2] = useTranslation('toast');
  const { relation, poId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const profileType = giveProfile(relation);

  const [typeOfMove, setTypeOfMove] = useState({});
  // const defaultDate = new Date(new Date().setDate(new Date().getDate() + 1));
  /*   const initialScheduledPickupDate = new Date(defaultDate);
  initialScheduledPickupDate.setHours(14, 0, 0, 0);
  const initialScheduledPickupToDate = new Date(defaultDate);
  initialScheduledPickupToDate.setHours(20, 0, 0, 0); */

  const isConsoliatedBooking = !!customIds?.length;
  let defaultTab = '';
  if (consigneeId) defaultTab = 'product details';
  else if (isConsole) defaultTab = 'product';
  else if (isConsoliatedBooking) defaultTab = 'consolidated packaging details';
  else defaultTab = 'booking details';
  const [supplierTab, setSupplierTab] = useState(defaultTab);
  // const { toggleVendorPackagePer } = usePermissionTabs();

  const [tabDetails, setTabDetails] = useState({
    bookingDetails: false,
    productDetails: false,
    productConsole: false,
    packagingDetails: false,
    consolidatedPkgDetails: false,
    shipmentDetails: false,
    confirmEntities: false,
    disablePkgDetails: true,
    disableShipDetails: isConsole || !!consigneeId,
    disableNxtShip: true,
    packagedetailsconsole: false,
    disablepkgdetailsconsole: false,
  });
  const [addForworder, setAddForworder] = useState(false);
  const [primaryForwarderList, setPrimaryForwarderList] = useState([]);
  const [pickUpForwarderList, setPickUpForwarderList] = useState([]);
  const [deliveryForwarderList, setDeliveryForwarderList] = useState([]);
  const [primaryDateForm, setPrimaryDateForm] = useState();
  const [pickUpDateForm, setPickUpDateForm] = useState();
  const [deliveryDateForm, setDeliveryDateForm] = useState();
  const [directShipmentEta, setDirectShipmentEta] = useState();
  const [directShipmentEtd, setDirectShipmentEtd] = useState();
  const [directShipmentBol, setDirectShipmentBol] = useState('');
  const [scheduledPickupDate, setScheduledPickupDate] = useState();
  const [scheduledPickupToDate, setScheduledPickupToDate] = useState();
  const [shipmentSwitchTo, setShipmentSwitchTo] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [pickUpSwitchTo, setPickUpSwitchTo] = useState(false);
  const [deliverySwitchTo, setDeliverySwitchTo] = useState(false);
  const [directShipmentSwitchTo, setDirectShipmentSwitchTo] = useState(false);
  const [update, setUpdate] = useState(false);
  const [updateCountry, setUpdateCountry] = useState(false);
  const [originStatus, setOriginStatus] = useState(false);
  const [destinationStatus, setDestinationStatus] = useState(false);
  const [isOriginDoor, setIsOriginDoor] = useState(false);
  const [isDestinationDoor, setIsDestinationDoor] = useState(false);
  const [selectedVendorType, setSelectedVendorType] = useState('primary');
  const [bookingInfo, setBookingInfo] = useState({});
  const [consoleEntityInfo, setConsoleEntityInfo] = useState({});
  const [bookingList, setBookingList] = useState([]);
  const commentData = useRef('');
  const [buyerAction, setBuyerAction] = useState({
    addPrimary: false,
    addPickup: false,
    addDelivery: false,
  });
  const [partiallyBooked, setPartiallyBooked] = useState(false);
  const [primaryBookingData, setPrimaryBookingData] = useState({});
  const [pickUpBookingData, setPickUpBookingData] = useState({});
  const [deliveryBookingData, setDeliveryBookingData] = useState({});
  const [pickUpHandledByPrimary, setPickUpHandledByPrimary] = useState(false);
  const [deliveryHandledByPrimary, setDeliveryHandledByPrimary] =
    useState(false);
  const [disablePrimaryAtSupplier, setDisablePrimaryAtSupplier] =
    useState(false);
  const [disablePickupAtSupplier, setDisablePickupAtSupplier] = useState(false);
  const [disableDeliveryAtSupplier, setDisableDeliveryAtSupplier] =
    useState(false);
  const [primaryBookingCompleted, setPrimaryBookingCompleted] = useState(false);
  const [pickupBookingCompleted, setPickupBookingCompleted] = useState(false);
  const [deliveryBookingCompleted, setDeliveryBookingCompleted] =
    useState(false);
  const [supplierUploadedDocs, setSupplierUploadedDocs] = useState([]);
  const [matchedBooking, setMatchedBooking] = useState(false);
  const [commentLabel, setCommentLabel] = useState('');
  const [bookingValue, setBookingValue] = useState({});
  const [destinationValues, setDestinationValues] = useState({});
  const [runOriginValidFlag, setRunOriginValidFlag] = useState(false);
  const [runDestValidFlag, setRunDestValidFlag] = useState(false);
  const [options, setOptions] = useState({
    originOptions: [],
    destinationOptions: [],
    pickUpOptions: [],
    deliveryOptions: [],
  });
  const [deliveryValues, setDeliveryValues] = useState({});
  const [originValues, setOriginValues] = useState({});
  const [pickUpValues, setPickUpValues] = useState({});
  const [confirmEntity, setConfirmEntity] = useState({});
  const [packageOptions, setPackageOptions] = useState([]);
  // const [packageDimensions, setPackageDimensions] = useState([]);
  // const [packageDetails, setPackageDetails] = useState({});
  const [commentPayload, setCommentPayload] = useState({
    primarycomment: '',
    pickupComment: '',
    deliverycomment: '',
  });
  const [bookingData, setBookingData] = useState([]);
  const perPageC = 15;
  const [totalPage, setTotalPage] = useState([1]);
  const [totalCount, setTotalCount] = useState();
  const [totalData, setTotalData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [originalQtys, setOriginalQtys] = useState([]);
  const [excelData, setExcelData] = useState([]);

  const [prodPackDetails, setProdPackDetails] = useState({
    kindOfGoods: 'General Cargo',
    cargoReadyDate: '',
    customClearance: false,
    HSCode: '',
    UNCode: [],
    hazmat: false,
  });
  const defaultProductSchema = {
    id: 1,
    name: '',
    quantity: null,
    length: null,
    width: null,
    height: null,
    grossWeight: null,
    pricePerUnit: null,
    currency: 'USD',
    measurementUnit: 'metric',
  };
  const [products, setProducts] = useState([defaultProductSchema]);
  const [linerData, setLinerData] = useState('');
  const [vendorPackageButton, setVendorPackageButton] = useState(false);
  const defaultPackageLabel = packageOptions?.filter(
    (pkg) => pkg?.value === 'Default Package'
  );
  const shouldPaginate = true;

  const defaultPackageSchema = {
    id: 0,
    name: '',
    quantity: null,
    length: null,
    width: null,
    height: null,
    grossWeight: null,
    measurementUnit: 'metric',
    selectedProductIds: [],
    currency: '',
  };

  const defaultConsolePkgSchema = {
    id: 0,
    package: {
      label: defaultPackageLabel?.[0]?.label,
      value: 'Default Package',
    },
    quantity: null,
    length: null,
    width: null,
    height: null,
    grossWeight: null,
    measurementUnit: 'metric',
    selectedProduct: [
      // {
      //   _id: '',
      //   itemCode: '',
      // },
    ],
  };

  const [consolePackageData, setConsolePackageData] = useState();

  // Default package edge case pending
  useEffect(() => {
    packageOptions?.forEach((pkgop, index) => {
      const newPackage = {
        ...defaultConsolePkgSchema,
        package: pkgop,
        id: index + 1, // Ensure unique, incrementing IDs starting from 1
      };

      setConsolePackageData((prev) => {
        const updatedPrev = prev;
        if (index) return [...updatedPrev, newPackage];
        return [newPackage];
      });
    });
  }, [packageOptions]);

  const toNumber = (val) => {
    const num = Number(val);
    return Number.isNaN(num) ? null : num;
  };

  const mapExcelToProducts = (data, prevProducts) => {
    const filteredData = data.slice(1);

    const newProducts = filteredData.map((item, index) => {
      const normalizedItem = Object.fromEntries(
        Object.entries(item).map(([key, value]) => [key.toLowerCase(), value])
      );
      return {
        ...defaultProductSchema,
        id: prevProducts.length + index + 1,
        name: normalizedItem['product name'] ?? '',
        quantity: toNumber(normalizedItem.qty),
        length: toNumber(normalizedItem.length),
        width: toNumber(normalizedItem.width),
        height: toNumber(normalizedItem.height),
        grossWeight: toNumber(normalizedItem['gross weight']),
        pricePerUnit: toNumber(normalizedItem['price per unit']),
        currency: normalizedItem['currency code']
          ? normalizedItem['currency code'].toString().trim().toUpperCase()
          : '',
      };
    });

    return [...prevProducts, ...newProducts];
  };
  useEffect(() => {
    if (excelData.length) {
      setProducts((prev) => mapExcelToProducts(excelData, prev));
    }
  }, [excelData]);

  const [packages, setPackages] = useState([defaultPackageSchema]);
  const [contractList, setContractList] = useState([]);
  const [selectedContract, setSelectedContract] = useState({});

  const { isShowing: isActivateUploadDislog, toggle: toggleUploadDialog } =
    useDialog();

  useEffect(() => {
    if (bookingList && selectedVendorType) {
      const foundBooking = bookingList.find(
        (booking) =>
          booking?.bookingType.toLowerCase() ===
          selectedVendorType.toLowerCase()
      );

      setMatchedBooking(foundBooking);

      const comment = foundBooking?.notes?.[0]?.comment;
      if (comment) {
        setCommentLabel(t('manageordersscreen.bookingdetailsbtn.viewcomment'));
      } else if (comment === '') {
        setCommentLabel(t('manageordersscreen.bookingdetailsbtn.nocomment'));
      } else {
        setCommentLabel(t('manageordersscreen.bookingdetailsbtn.addcommet'));
      }
    }
  }, [bookingList, selectedVendorType]);

  const pageCount = () => {
    const totalPageCount =
      totalCount > perPageC ? Math.floor(totalCount / perPageC) : 1;
    const totalPageNos = [1];
    for (let iCtr = 2; iCtr <= totalPageCount; iCtr++) {
      totalPageNos.push(iCtr);
    }
    if (totalPageCount * perPageC < totalCount) {
      totalPageNos.push(totalPageCount + 1);
    }
    setTotalPage(totalPageNos);
    setTotalData(totalCount);
  };

  const swicthPage = (page) => {
    setPageNumber(page);
  };

  useEffect(() => {
    if (totalCount) {
      pageCount();
    }
  }, [totalCount]);

  const handleCommentSubmit = useCallback(
    (commentValue) => {
      if (selectedVendorType === 'primary') {
        setCommentPayload((prev) => ({
          ...prev,
          primarycomment: commentValue,
        }));
      } else if (selectedVendorType === 'pickUp') {
        setCommentPayload((prev) => ({
          ...prev,
          pickupComment: commentValue,
        }));
      } else if (selectedVendorType === 'delivery') {
        setCommentPayload((prev) => ({
          ...prev,
          deliverycomment: commentValue,
        }));
      }
    },
    [selectedVendorType]
  );

  const { loading, refetch } = useQuery(FETCH_BOOKING, {
    notifyOnNetworkStatusChange: true,
    variables: {
      input: {
        referenceId: itemsData?.referenceId,
        poId,
        profileType,
      },
    },
    skip: !itemsData?.referenceId,
    onCompleted: (data) => {
      setBookingInfo({
        ...data?.FetchBookingTypeList?.data?.bookingDetails,
        defaultIncoTerm: itemsData?.defaultIncoTerm,
        ...(isConsoliatedBooking && {
          mode: { label: 'Inland', value: 'Inland' },
        }),
      });
      setBookingList(data?.FetchBookingTypeList?.data?.bookings);
      commentData.current =
        data?.FetchBookingTypeList?.data?.bookingDetails?.attachmentComment;
    },
  });

  const isVitroConsoleBulk = !!bulkVitroRefIds?.length;

  const { loading: loading2, refetch: refetch2 } = useQuery(
    FETCH_CONSOLE_BULK_BOOKING,
    {
      notifyOnNetworkStatusChange: true,
      variables: {
        input: {
          referenceIds: bulkVitroRefIds,
          profileType,
        },
      },
      skip: !isVitroConsoleBulk,
      onCompleted: (data) => {
        const bookingDetails = data?.getBookingTypeList?.data?.bookingDetails;

        const fixedPackages = bookingDetails?.packages?.map((pkg) => {
          let length;
          let width;
          let height;

          if (typeof pkg?.dimentions === 'string') {
            const parts = pkg.dimentions.split('x').map(Number);
            [length, width, height] = parts;
          }

          const fixedLineItems = pkg?.lineItems?.map((item) => {
            let l;
            let w;
            let h;

            if (typeof item?.dimensions === 'string') {
              const parts = item.dimensions.split('x').map(Number);
              [l, w, h] = parts;
            }

            return {
              ...item,
              dimensions:
                l !== undefined && w !== undefined && h !== undefined
                  ? [{ length: l, width: w, height: h }]
                  : [],
            };
          });

          return {
            ...pkg,
            dimentions:
              length !== undefined &&
              width !== undefined &&
              height !== undefined
                ? { length, width, height }
                : null,
            lineItems: fixedLineItems,
          };
        });

        setBookingInfo({
          ...bookingDetails,
          packages: fixedPackages,
          bulkIncoTerm: bookingDetails?.incoterm,
        });
        setBookingList(data?.getBookingTypeList?.data?.bookings);
      },
    }
  );

  const { data: materialList } = useQuery(MATERIAL_LIST, {
    notifyOnNetworkStatusChange: true,
    variables: {
      input: {
        customIds,
        profileType,
      },
    },
    skip: !isConsoliatedBooking,
  });

  const { data: warehouseList } = useQuery(WAREHOUSE_LIST, {
    notifyOnNetworkStatusChange: true,
    skip: isConsole,
    fetchPolicy: 'cache-and-network',
  });

  const [fetchPackageList] = useLazyQuery(PACKAGE_LIST, {
    onCompleted: (webData) => {
      setPackageOptions(webData?.ListPackageTypes);
    },
    fetchPolicy: 'cache-and-network',
  });

  const [listBookingData, { loading: isConsoleLoading }] = useLazyQuery(
    consolidationSelectionList
  );

  const shipmentRef = useRef();

  const triggerChildContractedApi = () => {
    shipmentRef.current?.handleShipmentSubmit();
  };

  const getBookingList = () => {
    const profileTypeConsole = profileType;
    listBookingData({
      variables: {
        input: {
          ...customIdsBooking,
          action:
            modeSelectionConsole === 'Air' ? 'airBooking' : 'oceanBooking',
          profileType: profileTypeConsole,
          page: pageNumber,
          perPage: perPageC,
        },
      },
      onCompleted: (data) => {
        setBookingData(data?.conditionalSelectionList?.data);
        setOriginalQtys((prev) => {
          const newQtys = data?.conditionalSelectionList?.data?.map((pkg) => ({
            _id: pkg?._id,
            shippedQty: pkg?.shippedQty,
          }));
          return [...prev, ...newQtys];
        });
        setTotalCount(data?.conditionalSelectionList?.totalCount);
        setConsoleEntityInfo({
          ...data?.conditionalSelectionList,
          buyerDetails: {
            ...data?.conditionalSelectionList?.buyerDetails?.data?.[0], // take first object from array
            entityDetails: data.buyerDetails?.entityDetails || null,
            entityERPValue: data.buyerDetails?.entityERPValue || null,
          },
          supplierDetails: {
            ...data?.conditionalSelectionList?.supplierDetails?.data?.[0], // take first object from array
            entityDetails: data.supplierDetails?.entityDetails || null,
            entityERPValue: data.supplierDetails?.entityERPValue || null,
          },
        });
      },
    });
  };

  useEffect(() => {
    if (consigneeId || isConsole) fetchPackageList();
  }, [consigneeId, isConsole]);

  useEffect(() => {
    if (modeSelectionConsole) getBookingList();
  }, [modeSelectionConsole]);

  useEffect(() => {
    if (
      isConsole &&
      !tableData.some((item) => item.pageNumberC === pageNumber)
    ) {
      getBookingList();
    }
  }, [pageNumber]);

  useEffect(() => {
    const bookVal = getBookingValue({
      bookingInfo,
      isConsoliatedBooking,
      isVitroConsoleBulk,
    });
    if (isConsoliatedBooking) {
      bookVal.mode.label = t(
        'manageordersscreen.createbookingmenu.shipmentdetails.modeOptions.Inland'
      );
    }
    setBookingValue(bookVal);
    setDestinationValues(defaultDestinationValues(bookingInfo));
    setOriginValues(defaultOriginValue(bookingInfo));

    const defaultDeliveryAddress = findDefaultDeliveryAddress(bookingList);
    const defaultPickUpAddress = findDefaultPickUpAddress(bookingList);
    setDeliveryValues(defaultDeliveryValues(defaultDeliveryAddress));
    setPickUpValues(defaultPickUpValues(defaultPickUpAddress));

    const { notifyParty, consigneeDetail } =
      findNotifyPartyAndConsignee(bookingInfo);
    setConfirmEntity({ notificationDetail: notifyParty, consigneeDetail });

    bookingList?.forEach((obj) => {
      if (obj?.bookingType === 'Primary') {
        if (obj?.bookHandle?.pickup) {
          setBuyerAction((prev) => ({ ...prev, addPickup: true }));
          setPickUpHandledByPrimary(true);
        }
        if (obj?.bookHandle?.delivery) {
          setBuyerAction((prev) => ({ ...prev, addDelivery: true }));
          setDeliveryHandledByPrimary(true);
        }
        setBuyerAction((prev) => ({ ...prev, addPrimary: true }));
        setPrimaryBookingData(obj);
      } else if (obj?.bookingType === 'Delivery') {
        setBuyerAction((prev) => ({ ...prev, addDelivery: true }));
        setDeliveryBookingData(obj);
      } else if (obj?.bookingType === 'Pickup') {
        buyerAction.addPickup = true;
        setBuyerAction((prev) => ({ ...prev, addPickup: true }));
        setPickUpBookingData(obj);
      }
    });

    setPartiallyBooked(
      getPartiallyBooked(bookingInfo, bookingList, profileType)
    );

    if (profileType === 'buyer') {
      if (bookingInfo?.directedBooking?.delivery) {
        setDeliverySwitchTo(true);
      }
      if (bookingInfo?.directedBooking?.pickup) {
        setPickUpSwitchTo(true);
      }
      if (bookingInfo?.directedBooking?.primary) {
        setShipmentSwitchTo(true);
      }
    }
  }, [bookingInfo, bookingList]);

  // profileType === supplier && (bookAction -> primary,pickup,delivery)
  // originStatus:true, destinationStatus:true, enable both, selectedVendorType: primary

  // profileType === supplier && (bookAction -> primary,pickup)
  // originStatus:true, destinationStatus:false, enable origin, disable dest, selectedVendorType: primary

  // profileType === supplier && (bookAction -> primary,delivery)
  // originStatus:false, destinationStatus:true, enable dest, disable origin, selectedVendorType: primary

  // profileType === supplier && (bookAction -> pickup, delivery)
  // originStatus:true, destinationStatus:false, enable origin, disable dest, selectedVendorType: pickup

  // profileType === supplier && (bookAction -> primary)
  // originStatus:false, destinationStatus:false and disable it, selectedVendorType: primary

  // profileType === supplier && (bookAction -> pickup)
  // originStatus:true, destinationStatus:false and disable it, selectedVendorType: pickup

  // profileType === supplier && (bookAction -> delivery)
  // originStatus:false, destinationStatus:true and disable it,selectedVendorType: delivery

  // if bookAction.primary = true && bookingList[0].bookingType='Primary' -> booking done
  // if bookAction.pickup = true && (bookingList[0].bookingType='Pickup'||(bookingList[0].bookingType='Primary' && bookingList[0].bookHandle.pickup=true))-> booking done
  // if bookAction.delivery = true && (bookingList[0].bookingType='Delivery'||(bookingList[0].bookingType='Primary' && bookingList[0].bookHandle.delivery=true))-> booking done

  useEffect(() => {
    bookingList?.forEach((obj) => {
      if (obj?.bookingType === 'Primary' && bookingInfo?.bookAction?.primary) {
        // primary booking done
        setPrimaryBookingCompleted(true);
      }
      if (
        bookingInfo?.bookAction?.pickup &&
        (obj?.bookingType === 'Pickup' ||
          (obj?.bookingType === 'Primary' && obj?.bookHandle?.pickup))
      ) {
        // pickup booking done
        setPickupBookingCompleted(true);
      }
      if (
        bookingInfo?.bookAction?.delivery &&
        (obj?.bookingType === 'Delivery' ||
          (obj?.bookingType === 'Primary' && obj?.bookHandle?.delivery))
      ) {
        setDeliveryBookingCompleted(true);
        // delivery booking done
      }
    });
  }, [
    bookingList,
    bookingInfo?.bookAction?.primary,
    bookingInfo?.bookAction?.pickup,
    bookingInfo?.bookAction?.delivery,
  ]);

  useEffect(() => {
    if (
      profileType === 'supplier' &&
      bookingInfo?._id &&
      !bookingInfo?.supplierBookingPermission
    ) {
      setShipmentSwitchTo(!bookingInfo?.bookAction?.primary);
      setPickUpSwitchTo(!bookingInfo?.bookAction?.pickup);
      setPickUpSwitchTo(!bookingInfo?.bookAction?.delivery);

      const bookAction = bookingInfo?.bookAction || {};
      const setStates = (vendorType, origin, destination) => {
        setSelectedVendorType(vendorType);
        setOriginStatus(origin);
        setDestinationStatus(destination);
      };

      if (bookAction.primary && bookAction.pickup && bookAction.delivery) {
        handlePrimaryPickupDeliveryBooking(
          primaryBookingCompleted,
          pickupBookingCompleted,
          deliveryBookingCompleted,
          setStates
        );
        setIsOriginDoor(true);
        setIsDestinationDoor(true);
      } else if (bookAction.primary && bookAction.pickup) {
        setDisableDeliveryAtSupplier(true);
        handlePrimaryPickup(
          primaryBookingCompleted,
          pickupBookingCompleted,
          setStates
        );
        setIsOriginDoor(true);
        setIsDestinationDoor(false);
      } else if (bookAction.primary && bookAction.delivery) {
        setDisablePickupAtSupplier(true);
        handlePrimaryDelivery(
          primaryBookingCompleted,
          deliveryBookingCompleted,
          setStates
        );
        setIsOriginDoor(false);
        setIsDestinationDoor(true);
      } else if (bookAction.delivery && bookAction.pickup) {
        handleDeliveryPickup(
          pickupBookingCompleted,
          deliveryBookingCompleted,
          setStates
        );
        setDisablePrimaryAtSupplier(true);
        setIsOriginDoor(true);
        setIsDestinationDoor(true);
      } else if (bookAction.primary) {
        handleSingleBookingType('primary', setStates);
        setDisablePickupAtSupplier(true);
        setDisableDeliveryAtSupplier(true);
        setIsOriginDoor(false);
        setIsDestinationDoor(false);
      } else if (bookAction.pickup) {
        handleSingleBookingType('pickUp', setStates);
        setDisablePrimaryAtSupplier(true);
        setDisableDeliveryAtSupplier(true);
        setIsOriginDoor(true);
        setIsDestinationDoor(false);
      } else if (bookAction.delivery) {
        handleSingleBookingType('delivery', setStates);
        setDisablePrimaryAtSupplier(true);
        setDisablePickupAtSupplier(true);
        setIsOriginDoor(false);
        setIsDestinationDoor(true);
      }
    }
  }, [
    bookingInfo?.bookAction?.primary,
    bookingInfo?.bookAction?.pickup,
    bookingInfo?.bookAction?.delivery,
    primaryBookingCompleted,
    pickupBookingCompleted,
    deliveryBookingCompleted,
  ]);

  useEffect(() => {
    if (partiallyBooked) {
      if (profileType === 'buyer') {
        setOriginStatus(pickUpHandledByPrimary);
        setDestinationStatus(deliveryHandledByPrimary);
      }
      if (profileType === 'supplier' && pickupBookingCompleted) {
        setOriginStatus(pickUpHandledByPrimary);
      }
      if (profileType === 'supplier' && deliveryBookingCompleted) {
        setDestinationStatus(deliveryHandledByPrimary);
      }
      setTabDetails((prev) => {
        const updatedTabDetails = { ...prev };
        updatedTabDetails.bookingDetails = true;
        updatedTabDetails.shipmentDetails = true;
        updatedTabDetails.confirmEntities = true;
        updatedTabDetails.addForworder = true;
        return updatedTabDetails;
      });
      setSupplierTab('add forworder');
    }
  }, [partiallyBooked, pickUpHandledByPrimary, deliveryHandledByPrimary]);

  useEffect(() => {
    if (vendorPackageButton) {
      setTableData((prevData) =>
        prevData.map((item) => ({
          ...item,
          package: {
            label: defaultPackageLabel?.[0]?.label,
            value: 'Default Package',
          },
        }))
      );

      const allPrdIds = tableData?.map((data) => ({
        _id: data?._id,
        itemCode: data?.itemId,
      }));

      setConsolePackageData((prev) => {
        return prev?.map((pkg) => {
          // add all products in default package
          if (pkg?.package?.value === 'Default Package') {
            return {
              ...pkg,
              selectedProduct: allPrdIds,
            };
          }
          // remove all products from other packages
          return {
            ...pkg,
            selectedProduct: [],
          };
        });
      });

      toast.warning(
        t('manageordersscreen.sendbookingdetails.defaultpackageenable')
      );
    } else {
      setTableData((prevData) =>
        prevData.map((item) => ({
          ...item,
          package: {},
        }))
      );

      setConsolePackageData((prev) => {
        return prev?.map((pkg) => {
          // remove products from other packages
          return {
            ...pkg,
            selectedProduct: [],
          };
        });
      });
    }
  }, [vendorPackageButton]);

  useEffect(() => {
    if (
      (!partiallyBooked &&
        (profileType === 'buyer' ||
          profileType === 'customBroker' ||
          isConsole)) ||
      (profileType === 'supplier' && bookingInfo?.supplierBookingPermission)
    ) {
      switch (bookingValue?.typeOfMove?.value) {
        case 'port to door':
          setOriginStatus(false);
          setDestinationStatus(true);
          setIsOriginDoor(false);
          setIsDestinationDoor(true);
          break;

        case 'port to port':
          setOriginStatus(false);
          setDestinationStatus(false);
          setIsOriginDoor(false);
          setIsDestinationDoor(false);
          break;

        case 'door to door':
          setOriginStatus(true);
          setDestinationStatus(true);
          setIsOriginDoor(true);
          setIsDestinationDoor(true);
          break;

        case 'door to port':
          setOriginStatus(true);
          setDestinationStatus(false);
          setIsOriginDoor(true);
          setIsDestinationDoor(false);
          break;

        default:
          break;
      }
    }
  }, [bookingValue?.typeOfMove?.value, directShipmentSwitchTo]);

  useEffect(() => {
    if (partiallyBooked && profileType === 'buyer') {
      if (
        bookingValue?.typeOfMove?.value === 'door to port' ||
        bookingValue?.typeOfMove?.value === 'door to door'
      ) {
        setIsOriginDoor(!pickUpHandledByPrimary || !buyerAction?.addPickup);
      }
      if (
        bookingValue?.typeOfMove?.value === 'door to door' ||
        bookingValue?.typeOfMove?.value === 'port to door'
      ) {
        setIsDestinationDoor(
          !deliveryHandledByPrimary || !buyerAction?.addDelivery
        );
      }
    }
  }, [partiallyBooked, bookingValue?.typeOfMove?.value]);

  // Sample docs payload
  // const docs = [
  //   {
  //     url: 'https://api.quloi.com/fileAPI/v1/service/getFile/65de22dad7d72170d2e2b433',
  //     size: '9002',
  //     path: 'omni/download (7)-1653039685688-1668773810231-1669264876912 (1)-1709056729945.jpg',
  //     originalName:
  //       'download (7)-1653039685688-1668773810231-1669264876912 (1).jpg',
  //     mimeType: 'image/jpeg',
  //     primarySelected: false,
  //     pickupSelected: false,
  //     deliverySelected: false,
  //   },
  // ];

  // const isOriginAddressInvalid = (showErrMsg = false) => {
  //   if (originValues?.origin !== '' && originValues?.origin) {
  //     const originAddress = getAddress({
  //       type: 'origin',
  //       originData: originValues,
  //       destinationData: {},
  //     });
  //     if (!originAddress?.city || !originAddress?.zipcode) {
  //       if (showErrMsg) toast.error(t2('buyer.error.invalidOrigin'));
  //       return true;
  //     }
  //   }
  //   return false;
  // };

  // since we now have new address format for inland
  const isOriginAddressInvalid = (showErrMsg = false) => {
    if (originValues?.origin !== '' && originValues?.origin) {
      if (
        !originValues?.originDoorAddress?.city?.name ||
        !originValues?.originDoorAddress?.zipCode?.name
      ) {
        if (showErrMsg) toast.error(t2('buyer.error.invalidOrigin'));
        return true;
      }
    }

    if (
      originValues?.origin &&
      destinationValues?.destination &&
      originValues?.origin === destinationValues?.destination
    ) {
      if (showErrMsg) toast.error(t2('buyer.error.origindestinationnotsame'));
      return true;
    }

    return false;
  };

  let updateExistingrow = [...tableData];
  const setNewValue = (e) => {
    let itemCode = '';
    let partName = '';
    updateExistingrow = updateExistingrow?.map((data) => {
      let newRow = data;
      const errorColumns = data.ErrorColumn || [];
      if (e._id === data._id) {
        if (e.columnName === 'grossWeight') {
          newRow = {
            ...data,
            [e.columnName]: e.values,
          };
          setTableData((prevData) =>
            prevData.map((item) =>
              item._id === e._id
                ? {
                    ...item,
                    grossWeight: e.values,
                  }
                : item
            )
          );
        }
        if (e.columnName === 'quantityToShip') {
          newRow = {
            ...data,
            [e.columnName]: e.values,
            ErrorColumn:
              e.values <= 0 || e.values > data.shippedQty
                ? [...errorColumns, e.columnName]
                : errorColumns.filter((item) => item !== e.columnName),
          };

          setTableData((prevData) =>
            prevData.map((item) => {
              return item._id === e._id
                ? {
                    ...item,
                    shippedQty: e.values,
                    errorMsg: e.values <= 0 || e.values > item?.shippedQty,
                  }
                : item;
            })
          );
        }
        if (e.columnName === 'package') {
          newRow = {
            ...data,
            [e.columnName]: e.values,
          };
          // defaultPackageSchemaConsole.forEach((pkgdata) => {});
          setTableData((prevData) =>
            prevData.map((item) => {
              if (item._id === e._id) {
                itemCode = item?.itemId;
                partName = item?.partName;

                return {
                  ...item,
                  package: {
                    label: e?.values?.label,
                    value: e?.values?.value,
                  },
                };
              }
              return item;
            })
          );

          setConsolePackageData((prev) => {
            const removePkgData = prev?.find((pkg) => {
              if (pkg?.package?.value !== e?.values?.value) {
                return pkg?.selectedProduct?.some(
                  (prod) => prod?._id === e?._id
                );
              }
              return false;
            });

            return prev?.map((pkg) => {
              // remove product if it exists in another package
              if (
                pkg?.id === removePkgData?.id &&
                removePkgData?.package?.value
              ) {
                return {
                  ...pkg,
                  selectedProduct: pkg?.selectedProduct?.filter?.(
                    (prd) => prd?._id !== e?._id
                  ),
                };
              }

              // add product if it matches current package
              if (pkg?.package?.value === e?.values?.value) {
                return {
                  ...pkg,
                  selectedProduct: [
                    ...(pkg?.selectedProduct || []),
                    { _id: e?._id, itemCode, partName },
                  ],
                };
              }

              // otherwise, return as is
              return pkg;
            });
          });
        } else {
          newRow = {
            ...data,
            [e.columnName]: e.values,
            isUndo: 1,
            isError: e.isError || false,
          };
        }
      }
      return newRow;
    });
  };

  const consoleBookingColumnsUpdate = buyerBookingConsole({
    packageOptions,
    setNewValue,
    vendorPackageButton,
    originalQtys,
  });

  // const isDestAddressInvalid = (showErrMsg = false) => {
  //   if (
  //     destinationValues?.destination !== '' &&
  //     destinationValues?.destination
  //   ) {
  //     const destinationAddress = getAddress({
  //       type: 'destination',
  //       destinationData: destinationValues,
  //       originData: {},
  //     });

  //     if (!destinationAddress?.city || !destinationAddress?.zipcode) {
  //       if (showErrMsg) toast.error(t2('buyer.error.invalidDestination'));
  //       return true;
  //     }
  //   }
  //   return false;
  // };

  // since we now have new address format for inland
  const isDestAddressInvalid = (showErrMsg = false) => {
    if (
      destinationValues?.destination !== '' &&
      destinationValues?.destination
    ) {
      if (
        !destinationValues?.destinationDoorAddress?.city?.name ||
        !destinationValues?.destinationDoorAddress?.zipCode?.name
      ) {
        if (showErrMsg) toast.error(t2('buyer.error.invalidDestination'));
        return true;
      }
    }

    if (
      originValues?.origin &&
      destinationValues?.destination &&
      originValues?.origin === destinationValues?.destination
    ) {
      if (showErrMsg) toast.error(t2('buyer.error.origindestinationnotsame'));
      return true;
    }

    return false;
  };

  useEffect(() => {
    if (bookingValue?.mode?.value === 'Inland') isOriginAddressInvalid(true);
  }, [runOriginValidFlag]);

  useEffect(() => {
    if (bookingValue?.mode?.value === 'Inland') isDestAddressInvalid(true);
  }, [runDestValidFlag]);

  const updateSupplierUploadedDocs = useCallback((e, vendorType, url) => {
    setSupplierUploadedDocs((prev) => {
      const updatedPrev = prev?.map((doc) => {
        if (doc?.url === url) {
          if (vendorType === 'primary') {
            return { ...doc, primarySelected: e?.target?.checked };
          }
          if (vendorType === 'pickup') {
            return { ...doc, pickupSelected: e?.target?.checked };
          }
          if (vendorType === 'delivery') {
            return { ...doc, deliverySelected: e?.target?.checked };
          }
        }
        return doc;
      });
      return updatedPrev;
    });
  }, []);

  const setDisableNxtShip = (disable) => {
    setTabDetails((prev) => {
      const updatedTabDetails = { ...prev };
      updatedTabDetails.disableNxtShip = disable;
      return updatedTabDetails;
    });
  };

  const setDisableShip = (disable) => {
    setTabDetails((prev) => {
      const updatedTabDetails = { ...prev };
      updatedTabDetails.disableShipDetails = disable;
      return updatedTabDetails;
    });
  };

  const disableNxtShipFunction = () => {
    if (bookingValue?.mode?.value === undefined) {
      setDisableNxtShip(true);
      return true;
    }
    if (
      (bookingValue?.airFreightType?.value === undefined ||
        bookingValue?.airFreightType?.value === '') &&
      bookingValue?.mode?.value === 'Air' &&
      isConsole
    ) {
      setDisableNxtShip(true);
      return true;
    }

    if (!bookingValue?.weightUnit?.value && consigneeId) {
      setDisableNxtShip(true);
      return true;
    }

    if (bookingValue?.mode?.value === 'Ocean') {
      if (
        bookingValue?.containerType?.value === '' ||
        bookingValue?.containerType?.value === undefined
      ) {
        setDisableNxtShip(true);
        return true;
      }

      if (bookingValue?.containerType?.value === 'FCL') {
        const equipmentType = bookingValue?.equipmentType?.value;
        const equipTypeQty = Number(bookingValue?.equipTypeQty);
        if (!equipmentType || equipTypeQty <= 0 || Number.isNaN(equipTypeQty)) {
          setDisableNxtShip(true);
          return true;
        }
      }
    }
    if (bookingValue?.mode?.value === 'Inland') {
      if (
        bookingValue?.cargoLoad?.value === '' ||
        bookingValue?.cargoLoad?.value === undefined
      ) {
        setDisableNxtShip(true);
        return true;
      }

      if (bookingValue?.cargoLoad?.value === 'FTL') {
        const numberOfTrucks = Number(bookingValue?.numberOfTrucks);
        if (
          numberOfTrucks <= 0 ||
          Number.isNaN(numberOfTrucks) ||
          bookingValue?.truckType?.value === '' ||
          bookingValue?.truckType?.value === undefined
        ) {
          setDisableNxtShip(true);
          return true;
        }
      }
    }
    if (
      bookingValue?.mode?.value === '' ||
      bookingValue?.mode?.value === undefined
    ) {
      setDisableNxtShip(true);
      return true;
    }
    if (
      bookingValue?.typeOfMove?.value === '' ||
      bookingValue?.typeOfMove?.value === undefined
    ) {
      setDisableNxtShip(true);
      return true;
    }
    if (
      bookingValue?.shipmentType?.value === '' ||
      bookingValue?.shipmentType?.value === undefined
    ) {
      setDisableNxtShip(true);
      return true;
    }
    if (
      bookingValue?.incoTerm?.value === '' ||
      (bookingValue?.incoTerm?.value === undefined &&
        (bookingValue?.mode?.value !== 'Inland' ||
          bookingValue?.shipmentType?.value !== 'Domestic') &&
        !isConsoliatedBooking)
    ) {
      setDisableNxtShip(true);
      return true;
    }

    if (bookingValue?.mode?.value === 'Inland') {
      if (isOriginAddressInvalid() || isDestAddressInvalid()) {
        setDisableNxtShip(true);
        return true;
      }
    }

    if (originValues?.origin === '' || !destinationValues?.destination) {
      setDisableNxtShip(true);
      return true;
    }

    if (consigneeId) {
      if (
        bookingValue?.shipmentFrequency?.value === '' ||
        bookingValue?.shipmentFrequency?.value === undefined
      ) {
        setDisableNxtShip(true);
        return true;
      }

      const totalWeight = Number(bookingValue?.totalWeight);
      if (totalWeight <= 0 || Number.isNaN(totalWeight)) {
        setDisableNxtShip(true);
        return true;
      }
    }

    if (
      (originValues?.origin !== '' || destinationValues?.destination !== '') &&
      originValues?.originCountry &&
      destinationValues?.destinationCountry &&
      originValues?.originCountry?.toString()?.toUpperCase() ===
        destinationValues?.destinationCountry?.toString()?.toUpperCase() &&
      updateCountry &&
      bookingValue?.mode?.value !== 'Inland'
    ) {
      toast.error(t2('buyer.error.origindestinationnotsame'));
      setDisableNxtShip(true);
      return true;
    }
    setDisableNxtShip(false);
    return false;
  };

  useEffect(() => {
    if (supplierTab === 'shipment details') disableNxtShipFunction();
  }, [bookingValue, originValues, destinationValues, supplierTab]);

  useEffect(() => {
    const formattedItemData = bookingData?.map((item) => {
      /*    const { length, height, width } = item.dimensions[0];
      const { cargoQty, bookedQty, grossWeight } = item; */
      //  const LXWXH = `${length} X ${width} X ${height}`;
      // check
      const packageType = {
        label: '',
        value: '',
      };

      return {
        ...item,
        package: packageType,
        pageNumberC: pageNumber,
        errorMsg: false,
      };
    });
    formattedItemData?.forEach((formatObj) => {
      const exists = tableData?.some(
        (tableObj) => tableObj?._id === formatObj?._id
      );
      if (!exists) {
        setTableData((prevTableData) => [...prevTableData, formatObj]);
      }
    });

    if (!bookingData.length && isConsole) setDisableShip(true);
  }, [bookingData]);

  useEffect(() => {
    if (directShipmentSwitchTo) {
      setDeliveryValues((prev) => ({
        ...prev,
        destination: '',
      }));
      setPickUpValues((prev) => ({
        ...prev,
        origin: '',
      }));
      setDirectShipmentEta('');
      setDirectShipmentEtd('');
    }
    if (
      !itemsData?.packages?.[0]?.isVendorPackage &&
      !bookingInfo?.packages?.[0]?.isVendorPackage
    ) {
      setDirectShipmentSwitchTo(false);
    }
  }, [supplierTab]);

  useEffect(() => {
    if (isConsole) {
      if (vendorPackageButton) {
        setTableData((prevData) =>
          prevData.map((item) => ({
            ...item,
            package: {
              label: defaultPackageLabel?.[0]?.label,
              value: 'Default Package',
            },
          }))
        );
      }
      const isErrorPackage =
        !tableData.some((item) => item?.package?.value) ||
        tableData.some((item) => {
          const original = originalQtys.find((o) => o._id === item._id);
          return (
            item.shippedQty === '' ||
            Number(item.shippedQty) > Number(original?.shippedQty ?? 0)
          );
        });

      if (isErrorPackage) {
        setTabDetails((prev) => {
          const updatedTabDetails = { ...prev };
          updatedTabDetails.disablepkgdetailsconsole = true;
          return updatedTabDetails;
        });
        setDisableShip(true);
      } else {
        setTabDetails((prev) => {
          const updatedTabDetails = { ...prev };
          updatedTabDetails.disablepkgdetailsconsole = false;
          return updatedTabDetails;
        });
      }
    }
  }, [tableData]);
  useEffect(() => {
    setSelectedContract({});
  }, [
    bookingValue?.mode?.value,
    bookingValue?.cargoLoad,
    bookingValue?.truckType,
  ]);
  useEffect(() => {
    setPickUpDateForm('');
    setDeliveryDateForm('');
    setScheduledPickupToDate('');
    setScheduledPickupDate('');
    setPrimaryDateForm('');
  }, [bookingValue?.mode?.value]);

  useEffect(() => {
    if (isConsole) {
      const isPackageValid = (pkg) => {
        const {
          quantity,
          length,
          width,
          height,
          grossWeight,
          measurementUnit,
        } = pkg;

        return (
          quantity &&
          length &&
          width &&
          height &&
          grossWeight &&
          measurementUnit
        );
      };

      const isValid = consolePackageData
        ?.filter((pkg) =>
          pkg.package.value !== 'Default Package'
            ? pkg?.selectedProduct?.length
            : false
        )
        .every((pkg) => isPackageValid(pkg));

      if (isValid) {
        setDisableShip(false);
      } else {
        setDisableNxtShip(true);
        setDisableShip(true);
      }
    }
  }, [consolePackageData]);

  const setBookingVal = (fieldName) => (e) => {
    setBookingValue((prev) => ({
      ...prev,
      [fieldName]: e,
    }));
  };

  const setOptionValues = (fieldName) => (e) => {
    setOptions((prev) => ({
      ...prev,
      [fieldName]: e,
    }));
  };

  const setDestyValues = (fieldName) => (e) => {
    if (fieldName === 'destinationCountry') {
      setUpdateCountry(true);
    }
    setDestinationValues((prev) => ({
      ...prev,
      [fieldName]: e,
    }));
    if (fieldName === 'destinationCountry' && e) {
      setRunDestValidFlag((prev) => !prev);
    }
  };

  const setDeliveryVal = (fieldName) => (e) => {
    setDeliveryValues((prev) => ({
      ...prev,
      [fieldName]: e,
    }));
  };

  const setOriginVal = (fieldName) => (e) => {
    setOriginValues((prev) => ({
      ...prev,
      [fieldName]: e,
    }));
    if (fieldName === 'originCountry' && e) {
      setRunOriginValidFlag((prev) => !prev);
    }
  };

  const setPickUpVal = (fieldName) => (e) => {
    setPickUpValues((prev) => ({
      ...prev,
      [fieldName]: e,
    }));
  };

  const handleDestinationStatus = useCallback(() => {
    if (selectedVendorType === 'primary') {
      setDestinationStatus((prev) => !prev);
    }
  }, [selectedVendorType]);

  const handleOriginStatus = useCallback(() => {
    if (selectedVendorType === 'primary') {
      setOriginStatus((prev) => !prev);
    }
  }, [selectedVendorType]);

  const setEntityDetails = (fieldName) => (e) => {
    setConfirmEntity((prev) => ({ ...prev, [fieldName]: e }));
  };

  useEffect(() => {
    if (bookingValue?.mode?.value === 'Inland') {
      setBookingVal('typeOfMove')({
        label: t(
          'manageordersscreen.createbookingmenu.shipmentdetails.typeOfMoveOptions.door to door'
        ),
        value: 'door to door',
      });
    }
  }, [bookingValue?.mode?.value]);

  if (profileType === 'buyer' && bookingValue?.mode?.value) {
    if (
      (bookingValue?.typeOfMove?.value === 'port to port' ||
        bookingValue?.mode?.value === 'Inland') &&
      (primaryBookingCompleted || bookingInfo?.directedBooking?.primary)
    ) {
      toggleViewDetailsModal();
      searchParams.delete('popover');
      searchParams.delete('popId');
      setSearchParams(searchParams);
      refetchOrderDetails();
    } else if (
      (primaryBookingCompleted || bookingInfo?.directedBooking?.primary) &&
      (bookingValue?.mode?.value !== 'Inland' &&
      bookingValue?.typeOfMove?.value?.includes('door to')
        ? pickupBookingCompleted || bookingInfo?.directedBooking?.pickup
        : true) &&
      (bookingValue?.mode?.value !== 'Inland' &&
      bookingValue?.typeOfMove?.value?.includes('to door')
        ? deliveryBookingCompleted || bookingInfo?.directedBooking?.delivery
        : true)
    ) {
      toggleViewDetailsModal();
      searchParams.delete('popover');
      searchParams.delete('popId');
      setSearchParams(searchParams);
      refetchOrderDetails();
    }
  } else if (
    profileType === 'supplier' &&
    bookingInfo?._id &&
    !bookingInfo?.supplierBookingPermission &&
    bookingValue?.mode?.value
  ) {
    if (bookingValue?.mode?.value === 'Inland' && primaryBookingCompleted) {
      toggleViewDetailsModal();
      searchParams.delete('popover');
      searchParams.delete('popId');
      setSearchParams(searchParams);
      refetchOrderDetails();
    } else if (
      (bookingInfo?.directedBooking?.primary ||
        bookingInfo?.directedBooking?.pickup ||
        bookingInfo?.directedBooking?.delivery) &&
      (bookingInfo?.directedBooking?.primary
        ? primaryBookingCompleted
        : true) &&
      (bookingInfo?.directedBooking?.pickup ? pickupBookingCompleted : true) &&
      (bookingInfo?.directedBooking?.delivery ? deliveryBookingCompleted : true)
    ) {
      toggleViewDetailsModal();
      searchParams.delete('popover');
      searchParams.delete('popId');
      setSearchParams(searchParams);
      refetchOrderDetails();
    }
  } else if (
    profileType === 'supplier' &&
    bookingInfo?.supplierBookingPermission &&
    bookingValue?.mode?.value &&
    primaryBookingCompleted
  ) {
    toggleViewDetailsModal();
    searchParams.delete('popover');
    searchParams.delete('popId');
    setSearchParams(searchParams);
    refetchOrderDetails();
  }

  // to style left menu buttons in case of Send to Supplier
  const isWarning = useCallback(
    (type) => {
      const isBooking = bookingInfo?.directedBooking?.[type.toLowerCase()];
      const isBookingList = bookingList?.find(
        (obj) => obj?.bookingType.toLowerCase() === type.toLowerCase()
      );

      let isSwitch;
      if (type === 'primary') {
        isSwitch = shipmentSwitchTo;
      } else if (type === 'pickUp') {
        isSwitch = pickUpSwitchTo;
      } else if (type === 'delivery') {
        isSwitch = deliverySwitchTo;
      }

      return (
        profileType === 'buyer' &&
        (isSwitch || isBooking) &&
        !isBookingList &&
        !(
          (type === 'pickUp' && pickUpHandledByPrimary) ||
          (type === 'delivery' && deliveryHandledByPrimary)
        )
      );
    },
    [
      profileType,
      bookingInfo,
      bookingList,
      shipmentSwitchTo,
      pickUpSwitchTo,
      deliverySwitchTo,
      pickUpHandledByPrimary,
      deliveryHandledByPrimary,
    ]
  );

  // to disable Pick-up and/or Delivery buttons in left menu
  const isDisabled = useCallback(
    (type) => {
      const isBuyer = profileType === 'buyer';

      if (type === 'Primary') {
        return disablePrimaryAtSupplier;
      }

      if (type === 'Pickup') {
        if (isBuyer) {
          if (!partiallyBooked && !(isOriginDoor && !originStatus)) {
            return true;
          }
          if (partiallyBooked && !isOriginDoor) {
            return true;
          }
          if (pickUpHandledByPrimary) {
            return true;
          }
          return false;
        }

        if (disablePickupAtSupplier) {
          return true;
        }
        if (!(isOriginDoor && !originStatus)) {
          return true;
        }
        return false;
      }

      if (type === 'Delivery') {
        if (isBuyer) {
          if (!partiallyBooked && !(isDestinationDoor && !destinationStatus)) {
            return true;
          }
          if (partiallyBooked && !isDestinationDoor) {
            return true;
          }
          if (deliveryHandledByPrimary) {
            return true;
          }
          if (destinationStatus) {
            return true;
          }
          return false;
        }

        if (disableDeliveryAtSupplier) {
          return true;
        }
        if (!(isDestinationDoor && !destinationStatus)) {
          return true;
        }
        return false;
      }

      return false;
    },
    [
      profileType,
      disablePrimaryAtSupplier,
      partiallyBooked,
      isOriginDoor,
      originStatus,
      pickUpHandledByPrimary,
      disablePickupAtSupplier,
      isDestinationDoor,
      destinationStatus,
      deliveryHandledByPrimary,
      disableDeliveryAtSupplier,
    ]
  );

  const isDisabledIcon = useCallback(
    (type) => {
      const isBuyer = profileType === 'buyer';

      if (type === 'Primary') {
        return disablePrimaryAtSupplier;
      }

      if (type === 'Pickup') {
        if (isBuyer) {
          if (!partiallyBooked && !(isOriginDoor && !originStatus)) {
            return <CreateBookingDisabledIcon />;
          }
          if (partiallyBooked && !isOriginDoor) {
            return <CreateBookingDisabledIcon />;
          }
          if (pickUpHandledByPrimary) {
            return <CreateBookingDisabledIcon />;
          }
          if (originStatus) {
            return <CreateBookingDisabledIcon />;
          }
          return false;
        }

        if (disablePickupAtSupplier) {
          return <CreateBookingDisabledIcon />;
        }
        if (!(isOriginDoor && !originStatus)) {
          return <CreateBookingDisabledIcon />;
        }
        return false;
      }

      if (type === 'Delivery') {
        if (isBuyer) {
          if (!partiallyBooked && !(isDestinationDoor && !destinationStatus)) {
            return <CreateBookingDisabledIcon />;
          }
          if (partiallyBooked && !isDestinationDoor) {
            return <CreateBookingDisabledIcon />;
          }
          if (deliveryHandledByPrimary) {
            return <CreateBookingDisabledIcon />;
          }
          if (destinationStatus) {
            return <CreateBookingDisabledIcon />;
          }
          return false;
        }

        if (disableDeliveryAtSupplier) {
          return <CreateBookingDisabledIcon />;
        }
        if (!(isDestinationDoor && !destinationStatus)) {
          return <CreateBookingDisabledIcon />;
        }
        return false;
      }

      return false;
    },
    [
      profileType,
      disablePrimaryAtSupplier,
      partiallyBooked,
      isOriginDoor,
      originStatus,
      pickUpHandledByPrimary,
      disablePickupAtSupplier,
      isDestinationDoor,
      destinationStatus,
      deliveryHandledByPrimary,
      disableDeliveryAtSupplier,
    ]
  );

  const getClassName = useCallback(
    (type) => {
      let isDone;
      if (type === 'primary') {
        isDone = buyerAction?.addPrimary || primaryBookingCompleted;
      } else if (type === 'pickUp') {
        isDone = buyerAction?.addPickup || pickupBookingCompleted;
      } else if (type === 'delivery') {
        isDone = buyerAction?.addDelivery || deliveryBookingCompleted;
      }
      const formattedType =
        type.charAt(0).toUpperCase() + type.toLowerCase().slice(1);

      return `
      ${
        selectedVendorType === type &&
        !buyerAction[`add${formattedType}`] &&
        !(isWarning(type) && selectedVendorType === type)
          ? ' active-selected'
          : ''
      }${isDone && selectedVendorType === type ? ' done-selected' : ''}${
        isDone && selectedVendorType !== type ? ' done' : ''
      }${isWarning(type) && selectedVendorType !== type ? ' warning' : ''}${
        isWarning(type) && selectedVendorType === type
          ? ' warning-selected'
          : ''
      }

    `;
    },
    [
      buyerAction,
      primaryBookingCompleted,
      pickupBookingCompleted,
      deliveryBookingCompleted,
      selectedVendorType,
      isWarning,
    ]
  );

  const getIcons = useCallback(
    (type) => {
      let isDone;
      if (type === 'primary') {
        isDone = buyerAction?.addPrimary || primaryBookingCompleted;
      } else if (type === 'pickUp') {
        isDone = buyerAction?.addPickup || pickupBookingCompleted;
      } else if (type === 'delivery') {
        isDone = buyerAction?.addDelivery || deliveryBookingCompleted;
      }

      const formattedType =
        type.charAt(0).toUpperCase() + type.toLowerCase().slice(1);

      return (
        <>
          {selectedVendorType === type &&
            !buyerAction[`add${formattedType}`] &&
            !(
              isWarning(type) &&
              (selectedVendorType === type || selectedVendorType !== type)
            ) && <CreateBookingCurrentIcon />}

          {isDone && selectedVendorType === type && (
            <CreateBookingCompletedIcon />
          )}

          {isDone && selectedVendorType !== type && (
            <CreateBookingCompletedIcon />
          )}

          {isWarning(type) && selectedVendorType !== type && (
            <CreateBookingWarningIcon />
          )}

          {!(
            selectedVendorType === type && !buyerAction[`add${formattedType}`]
          ) &&
          !(isDone && selectedVendorType === type) &&
          !(isDone && selectedVendorType !== type) &&
          !(
            isWarning(type) &&
            (selectedVendorType === type || selectedVendorType !== type)
          ) ? (
            <CreateBookingPendingIcon />
          ) : null}

          {isWarning(type) && selectedVendorType === type ? (
            <CreateBookingWarningIcon />
          ) : null}
        </>
      );
    },
    [
      buyerAction,
      primaryBookingCompleted,
      pickupBookingCompleted,
      deliveryBookingCompleted,
      selectedVendorType,
      isWarning,
    ]
  );

  const handlConsolePackageTabSwitch = useCallback(() => {
    const isError = !tableData.some((item) => item?.package?.value?.trim());

    if (!isError) {
      setTabDetails((prev) => ({
        ...prev,
        productConsole: true,
      }));
      setSupplierTab('package details console');
    }
  }, [tableData]);

  const formProps = {
    pickUpDateForm,
    setPickUpDateForm,
    deliveryDateForm,
    setDeliveryDateForm,
    primaryDateForm,
    setPrimaryDateForm,
    scheduledPickupDate,
    setScheduledPickupDate,
    scheduledPickupToDate,
    setScheduledPickupToDate,
  };
  const bookingProps = {
    bookingInfo,
    bookingValue,
    matchedBooking,
    deliveryBookingData,
    deliveryBookingCompleted,
    pickUpBookingData,
    pickupBookingCompleted,
    primaryBookingData,
    primaryBookingCompleted,
    deliveryValues,
    pickUpValues,
    prodPackDetails,
    products,
    packages,
  };
  const shipmentProps = {
    linerData,
    directShipmentEta,
    directShipmentEtd,
    directShipmentBol,
    setLinerData,
    setDirectShipmentEta,
    setDirectShipmentEtd,
    setDirectShipmentBol,
  };
  const switchProps = {
    pickUpSwitchTo,
    deliverySwitchTo,
    shipmentSwitchTo,
    directShipmentSwitchTo,
    setShipmentSwitchTo,
    setPickUpSwitchTo,
    setDeliverySwitchTo,
    setDirectShipmentSwitchTo,
  };
  const forwarderProps = {
    primaryForwarderList,
    pickUpForwarderList,
    deliveryForwarderList,
    setPrimaryForwarderList,
    setPickUpForwarderList,
    setDeliveryForwarderList,
  };
  const handlerProps = {
    handleOriginStatus,
    handleDestinationStatus,
    updateSupplierUploadedDocs,
    handleCommentSubmit,
  };
  const miscProps = {
    buyerAction,
    selectedVendorType,
    options,
    commentLabel,
    supplierUploadedDocs,
    confirmEntity,
    commentPayload,
    originStatus,
    destinationStatus,
    originValues,
    destinationValues,
    isOriginDoor,
    isDestinationDoor,
    disablePrimaryAtSupplier,
    isActivateUploadDislog,
    toggleUploadDialog,
    update,
    isBulk,
    setOptionValues,
    setDeliveryVal,
    setPickUpVal,
    supplierTab,
    setSupplierTab,
    setAddForworder,
    consolePackageData,
    tableData,
  };
  const uiProps = {
    isDisabled,
    getClassName,
    isDisabledIcon,
    getIcons,
    setSelectedVendorType,
  };

  const consoleprops = {
    t,
    setVendorPackageButton,
    vendorPackageButton,
    supplierTab,
    consoleBookingColumnsUpdate,
    tableData,
    pageNumber,
    totalData,
    perPageC,
    swicthPage,
    setTabDetails,
    setSupplierTab,
    totalPage,
    packageOptions,
    consolePackageData,
    setConsolePackageData,
    handlConsolePackageTabSwitch,
    isConsoleLoading,
    bookingData,
    originalQtys,
  };

  const isBookingDetailsReady = isVitroConsoleBulk ? !loading2 : !loading;

  return (
    <>
      {/* {loading && <GlobalLoader newLoad={true} height={80} width={80} />}
      {!loading && ( */}
      <div className="supplier-booking-container">
        <DialogPanel
          title={
            consigneeId
              ? t('manageordersscreen.askquotation.title')
              : t('manageordersscreen.createbookingmenu.title')
          }
          large="booking-details-title"
        >
          <DialogPanelBody className="pb-15">
            {loading ||
              (loading2 && (
                <GlobalLoader newLoad={true} height="6.944vw" width="6.944vw" />
              ))}
            {isBookingDetailsReady && (
              <div className="custom-tabs supplier-booking-wrapper">
                <ul className="custom-tab-list">
                  {isConsole && (
                    <li
                      className={`custom-tab-nav-item ${
                        tabDetails?.productConsole ? 'done' : ''
                      } ${supplierTab === 'product' ? 'current' : ''}`}
                    >
                      <button
                        type="button"
                        onClick={() => setSupplierTab('product')}
                      >
                        <SelectProductIcon />
                        {t('manageordersscreen.productdetails.title')}
                      </button>
                    </li>
                  )}
                  {consigneeId && (
                    <>
                      {' '}
                      <li
                        className={`custom-tab-nav-item ${
                          tabDetails?.productDetails ? 'done' : ''
                        } ${
                          supplierTab === 'product details' ? 'current' : ''
                        }`}
                      >
                        <button
                          type="button"
                          onClick={() => {
                            setSupplierTab('product details');
                          }}
                        >
                          <ProductDetailsIcon />
                          {t('manageordersscreen.productdetails.title')}
                        </button>
                      </li>
                      <li
                        className={`custom-tab-nav-item ${
                          tabDetails?.packagingDetails ? 'done' : ''
                        } ${
                          supplierTab === 'packaging details' ? 'current' : ''
                        }`}
                      >
                        <button
                          type="button"
                          disabled={tabDetails?.disablePkgDetails}
                          onClick={() => {
                            setSupplierTab('packaging details');
                            setTabDetails((prev) => {
                              const updatedTabDetails = { ...prev };
                              updatedTabDetails.productDetails = true;
                              return updatedTabDetails;
                            });
                          }}
                        >
                          <BookingDetailsIcon />
                          {t('manageordersscreen.packagingdetails.title')}
                        </button>
                      </li>
                    </>
                  )}

                  {!consigneeId && !isConsoliatedBooking && !isConsole && (
                    <li
                      className={`custom-tab-nav-item ${
                        tabDetails?.bookingDetails ? 'done' : ''
                      } ${supplierTab === 'booking details' ? 'current' : ''}`}
                    >
                      <button
                        type="button"
                        onClick={() => setSupplierTab('booking details')}
                      >
                        <BookingDetailsIcon />
                        {t('manageordersscreen.createbookingmenu.tabtitle')}
                      </button>
                    </li>
                  )}

                  {isConsoliatedBooking ? (
                    <li
                      className={`custom-tab-nav-item ${
                        tabDetails?.consolidatedPkgDetails ? 'done' : ''
                      } ${
                        supplierTab === 'consolidated packaging details'
                          ? 'current'
                          : ''
                      }`}
                    >
                      <button
                        type="button"
                        onClick={() => {
                          setSupplierTab('consolidated packaging details');
                          setTabDetails((prev) => {
                            const updatedTabDetails = { ...prev };
                            updatedTabDetails.consolidatedPkgDetails = true;
                            return updatedTabDetails;
                          });
                        }}
                      >
                        <BookingDetailsIcon />
                        {t('manageordersscreen.packagingdetails.title')}
                      </button>
                    </li>
                  ) : null}

                  {isConsole ? (
                    <li
                      className={`custom-tab-nav-item ${
                        tabDetails?.packagedetailsconsole ? 'done' : ''
                      } ${
                        supplierTab === 'package details console'
                          ? 'current'
                          : ''
                      }`}
                    >
                      <button
                        type="button"
                        onClick={() => {
                          handlConsolePackageTabSwitch();
                        }}
                        disabled={tabDetails?.disablepkgdetailsconsole}
                      >
                        <BookingDetailsIcon />
                        {t('manageordersscreen.packagingdetails.title')}
                      </button>
                    </li>
                  ) : null}

                  <li
                    className={`custom-tab-nav-item ${
                      tabDetails?.shipmentDetails ? 'done' : ''
                    } ${supplierTab === 'shipment details' ? 'current' : ''}`}
                  >
                    <button
                      type="button"
                      disabled={tabDetails?.disableShipDetails}
                      // add logic in handler func
                      onClick={() => {
                        setTabDetails((prev) => {
                          const updatedTabDetails = { ...prev };
                          updatedTabDetails.bookingDetails = true;
                          updatedTabDetails.productDetails = true;
                          updatedTabDetails.packagingDetails = true;
                          updatedTabDetails.consolidatedPkgDetails = true;
                          return updatedTabDetails;
                        });
                        setSupplierTab('shipment details');
                        if (profileType === 'buyer') {
                          if (partiallyBooked && !buyerAction?.addPrimary) {
                            setSelectedVendorType('primary');
                          } else if (
                            partiallyBooked &&
                            !buyerAction?.addPickup &&
                            (bookingValue?.typeOfMove?.value ===
                              'door to port' ||
                              bookingValue?.typeOfMove?.value ===
                                'door to door')
                          ) {
                            setSelectedVendorType('pickUp');
                          } else if (
                            partiallyBooked &&
                            !buyerAction?.addDelivery &&
                            (bookingValue?.typeOfMove?.value ===
                              'door to door' ||
                              bookingValue?.typeOfMove?.value ===
                                'port to door')
                          ) {
                            setSelectedVendorType('delivery');
                          } else {
                            setSelectedVendorType('primary');
                          }
                        }
                      }}
                    >
                      <ShipmentIcon />
                      {t(
                        'manageordersscreen.createbookingmenu.shipmentdetails.title'
                      )}
                    </button>
                  </li>
                  <li
                    className={`custom-tab-nav-item ${
                      tabDetails?.confirmEntities ? 'done' : ''
                    } ${supplierTab === 'confirm entity' ? 'current' : ''}`}
                  >
                    <button
                      type="button"
                      disabled={tabDetails.disableNxtShip}
                      // add logic in handler func
                      onClick={() => {
                        setTabDetails((prev) => {
                          const updatedTabDetails = { ...prev };
                          updatedTabDetails.shipmentDetails = true;
                          return updatedTabDetails;
                        });
                        if (supplierTab === 'shipment details') {
                          triggerChildContractedApi();
                        } else {
                          setSupplierTab('confirm entity');
                        }
                        if (profileType === 'buyer') {
                          if (partiallyBooked && !buyerAction?.addPrimary) {
                            setSelectedVendorType('primary');
                          } else if (
                            partiallyBooked &&
                            !buyerAction?.addPickup &&
                            (bookingValue?.typeOfMove?.value ===
                              'door to port' ||
                              bookingValue?.typeOfMove?.value ===
                                'door to door')
                          ) {
                            setSelectedVendorType('pickUp');
                          } else if (
                            partiallyBooked &&
                            !buyerAction?.addDelivery &&
                            (bookingValue?.typeOfMove?.value ===
                              'door to door' ||
                              bookingValue?.typeOfMove?.value ===
                                'port to door')
                          ) {
                            setSelectedVendorType('delivery');
                          } else {
                            setSelectedVendorType('primary');
                          }
                        }
                      }}
                    >
                      <ConfirmEntitiesIcon />
                      {t(
                        'manageordersscreen.createbookingmenu.confirmentities.title'
                      )}
                    </button>
                  </li>
                  <li
                    className={`custom-tab-nav-item ${
                      addForworder ? 'done' : ''
                    } ${supplierTab === 'add forworder' ? 'current' : ''}`}
                  >
                    <button
                      type="button"
                      disabled={
                        tabDetails?.disableNxtShip ||
                        (bookingValue?.cargoLoad?.value === 'FTL' &&
                          // eslint-disable-next-line quotes
                          bookingValue?.truckType?.value === "Dry box 53'" &&
                          supplierTab === 'shipment details')
                      }
                      // add logic in handler func
                      onClick={() => {
                        setTabDetails((prev) => {
                          const updatedTabDetails = { ...prev };
                          updatedTabDetails.confirmEntities = true;
                          return updatedTabDetails;
                        });
                        setUpdate(true);
                        setSupplierTab('add forworder');
                        if (profileType === 'buyer') {
                          if (partiallyBooked && !buyerAction?.addPrimary) {
                            setSelectedVendorType('primary');
                          } else if (
                            partiallyBooked &&
                            !buyerAction?.addPickup &&
                            (bookingValue?.typeOfMove?.value ===
                              'door to port' ||
                              bookingValue?.typeOfMove?.value ===
                                'door to door')
                          ) {
                            setSelectedVendorType('pickUp');
                          } else if (
                            partiallyBooked &&
                            !buyerAction?.addDelivery &&
                            (bookingValue?.typeOfMove?.value ===
                              'door to door' ||
                              bookingValue?.typeOfMove?.value ===
                                'port to door')
                          ) {
                            setSelectedVendorType('delivery');
                          } else {
                            setSelectedVendorType('primary');
                          }
                        }
                      }}
                    >
                      <AddForwarderIcon />
                      {t(
                        'manageordersscreen.createbookingmenu.addforwarder.title'
                      )}
                    </button>
                  </li>
                </ul>
                {!isConsoliatedBooking && supplierTab === 'booking details' ? (
                  <BookingDetailsTab
                    setSupplierTab={setSupplierTab}
                    bookingInfo={bookingInfo}
                    itemsData={itemsData}
                    commentData={commentData}
                    setTabDetails={setTabDetails}
                    columns={columns}
                    prodPackDetails={prodPackDetails}
                    setProdPackDetails={setProdPackDetails}
                  />
                ) : null}

                {supplierTab === 'consolidated packaging details' ? (
                  <ConsolidatedPkgDetailsTab
                    setSupplierTab={setSupplierTab}
                    materialsInfo={materialList?.MaterialsList?.data || []}
                    setTabDetails={setTabDetails}
                    prodPackDetails={prodPackDetails}
                    setProdPackDetails={setProdPackDetails}
                  />
                ) : null}

                {supplierTab === 'product' ||
                supplierTab === 'package details console' ? (
                  <ConsoleBooking consoleprops={consoleprops} />
                ) : null}

                {supplierTab === 'product details' ? (
                  <ProductDetailsTab
                    {...{
                      setSupplierTab,
                      prodPackDetails,
                      setProdPackDetails,
                      products,
                      setProducts,
                      setTabDetails,
                      packages,
                      setPackages,
                      setExcelData,
                      shouldPaginate,
                    }}
                  />
                ) : null}

                {supplierTab === 'packaging details' ? (
                  <PackagingDetailsTab
                    {...{
                      setSupplierTab,
                      packages,
                      setPackages,
                      products,
                      tabDetails,
                      setTabDetails,
                      packageOptions,
                    }}
                  />
                ) : null}

                {supplierTab === 'shipment details' ? (
                  <ShipmentDetailsTab
                    ref={shipmentRef}
                    setSupplierTab={setSupplierTab}
                    partiallyBooked={partiallyBooked}
                    bookingValue={bookingValue}
                    setBookingVal={setBookingVal}
                    originValues={originValues}
                    destinationValues={destinationValues}
                    setOriginVal={setOriginVal} // check
                    setOriginValues={setOriginValues}
                    setPickUpValues={setPickUpValues}
                    setDeliveryValues={setDeliveryValues}
                    setDestyValues={setDestyValues} // check
                    setDestinationValues={setDestinationValues}
                    setTabDetails={setTabDetails}
                    options={options}
                    setOptions={setOptions}
                    typeOfMove={typeOfMove}
                    setTypeOfMove={setTypeOfMove}
                    setBookingValue={setBookingValue}
                    setOptionValues={setOptionValues}
                    disableNxtShip={tabDetails.disableNxtShip}
                    consigneeId={consigneeId}
                    contractList={contractList}
                    setContractList={setContractList}
                    selectedContract={selectedContract}
                    setSelectedContract={setSelectedContract}
                    isConsoliatedBooking={isConsoliatedBooking}
                    warehouseList={warehouseList?.WarehouseList?.data}
                    setDirectShipmentSwitchTo={setDirectShipmentSwitchTo}
                    directShipmentSwitchTo={directShipmentSwitchTo}
                    modeSelectionConsole={modeSelectionConsole}
                    isConsole={isConsole}
                    isVitroConsoleBulk={isVitroConsoleBulk}
                  />
                ) : null}

                {supplierTab === 'confirm entity' ? (
                  <div className="supplier-booking-content">
                    <div className="add-document-wrapper">
                      <div className="d-flex w-100 add-document">
                        <div className="add-document-wrap">
                          <PanelCard
                            cardTitle={t(
                              'manageordersscreen.createbookingmenu.confirmentities.title'
                            )}
                            noShadow
                            border
                            disabled={partiallyBooked}
                          >
                            <ConfirmEntity
                              // @Nihal refactor this
                              buyerDetails={`${
                                (isConsole ? consoleEntityInfo : bookingInfo)
                                  ?.buyerDetails?.orgName
                              } ${
                                (isConsole ? consoleEntityInfo : bookingInfo)
                                  ?.buyerDetails?.entityDetails?.entityName
                                  ? `<br/>${
                                      (isConsole
                                        ? consoleEntityInfo
                                        : bookingInfo
                                      )?.buyerDetails?.entityDetails?.entityName
                                    }`
                                  : ''
                              } ${
                                (isConsole ? consoleEntityInfo : bookingInfo)
                                  ?.buyerDetails?.entityERPValue?.ERPValue ||
                                (isConsole ? consoleEntityInfo : bookingInfo)
                                  ?.buyerDetails?.orgERPValue?.ERPValue
                                  ? `<br/>${
                                      (isConsole
                                        ? consoleEntityInfo
                                        : bookingInfo
                                      )?.buyerDetails?.entityERPValue?.ERPValue
                                        ? (isConsole
                                            ? consoleEntityInfo
                                            : bookingInfo
                                          )?.buyerDetails?.entityERPValue
                                            ?.ERPValue
                                        : (isConsole
                                            ? consoleEntityInfo
                                            : bookingInfo
                                          )?.buyerDetails?.orgERPValue?.ERPValue
                                    }`
                                  : ''
                              }<br/>${
                                (isConsole ? consoleEntityInfo : bookingInfo)
                                  ?.buyerDetails?.orgAddress
                              } `}
                              supplierDetails={`${
                                (isConsole ? consoleEntityInfo : bookingInfo)
                                  ?.supplierDetails?.orgName
                              } ${
                                (isConsole ? consoleEntityInfo : bookingInfo)
                                  ?.supplierDetails?.entityDetails?.entityName
                                  ? `<br/>${
                                      (isConsole
                                        ? consoleEntityInfo
                                        : bookingInfo
                                      )?.supplierDetails?.entityDetails
                                        ?.entityName
                                    }`
                                  : ''
                              } ${
                                (isConsole ? consoleEntityInfo : bookingInfo)
                                  ?.supplierDetails?.entityERPValue?.ERPValue ||
                                (isConsole ? consoleEntityInfo : bookingInfo)
                                  ?.supplierDetails?.orgERPValue?.ERPValue
                                  ? `<br/>${
                                      (isConsole
                                        ? consoleEntityInfo
                                        : bookingInfo
                                      )?.supplierDetails?.entityERPValue
                                        ?.ERPValue
                                        ? (isConsole
                                            ? consoleEntityInfo
                                            : bookingInfo
                                          )?.supplierDetails?.entityERPValue
                                            ?.ERPValue
                                        : (isConsole
                                            ? consoleEntityInfo
                                            : bookingInfo
                                          )?.supplierDetails?.orgERPValue
                                            ?.ERPValue
                                    }`
                                  : ''
                              }<br/>${
                                (isConsole ? consoleEntityInfo : bookingInfo)
                                  ?.supplierDetails?.orgAddress
                              } `}
                              setNotificationDetail={setEntityDetails(
                                'notificationDetail'
                              )}
                              notificationDetail={
                                confirmEntity.notificationDetail
                              }
                              consigneeDetail={confirmEntity.consigneeDetail}
                              setConsigneeDetail={setEntityDetails(
                                'consigneeDetail'
                              )}
                              consigneeId={consigneeId}
                              isConsoliatedBooking={isConsoliatedBooking}
                              setDirectShipmentSwitchTo={
                                setDirectShipmentSwitchTo
                              }
                              directShipmentSwitchTo={directShipmentSwitchTo}
                            />
                          </PanelCard>
                        </div>
                      </div>
                      <div className="d-flex justify-between w-100">
                        <Button
                          label={t(
                            'manageordersscreen.createbookingmenu.confirmentities.back'
                          )}
                          styles="back"
                          size="large"
                          icon={<PrevIcon />}
                          spacing="0.694vw"
                          className="px-24"
                          onClick={() => {
                            setSupplierTab('shipment details');
                          }}
                        />
                        <Button
                          label={t(
                            'manageordersscreen.createbookingmenu.confirmentities.next'
                          )}
                          styles="submit"
                          size="large"
                          iconRight={<NextIcon />}
                          onClick={() => {
                            setTabDetails((prev) => {
                              const updatedTabDetails = { ...prev };
                              updatedTabDetails.confirmEntities = true;
                              return updatedTabDetails;
                            });
                            setUpdate(true);
                            setSupplierTab('add forworder');
                          }}
                          spacing="0.694vw"
                          className="px-24"
                        />
                      </div>
                    </div>
                  </div>
                ) : null}
                {supplierTab === 'add forworder' ? (
                  <div className="supplier-booking-content">
                    <AddForwarderTab
                      formProps={formProps}
                      bookingProps={bookingProps}
                      switchProps={switchProps}
                      forwarderProps={forwarderProps}
                      handlerProps={handlerProps}
                      miscProps={miscProps}
                      uiProps={uiProps}
                      refetch={bulkVitroRefIds?.length ? refetch2 : refetch}
                      consigneeId={consigneeId}
                      toggleRFQ={refetchRfqList}
                      selectedContract={selectedContract}
                      isConsoliatedBooking={isConsoliatedBooking}
                      customIds={customIds}
                      refetchConsolidatedList={refetchConsolidatedList}
                      toggleViewDetailsModal={toggleViewDetailsModal}
                      contractList={contractList}
                      shipmentProps={shipmentProps}
                      isVendorPackaging={
                        itemsData?.packages?.every(
                          (pkg) => pkg.isVendorPackage === true
                        ) ||
                        bookingInfo?.packages?.every(
                          (pkg) => pkg.isVendorPackage === true
                        )
                      }
                      isConsole={isConsole}
                      bulkVitroRefIds={bulkVitroRefIds}
                    />
                  </div>
                ) : null}
              </div>
            )}
          </DialogPanelBody>
        </DialogPanel>
      </div>
    </>
  );
}

export default BuyerBooking;
BuyerBooking.propTypes = {
  itemsData: PropTypes.instanceOf(Object),
  columns: PropTypes.arrayOf(PropTypes.string),
  toggleViewDetailsModal: PropTypes.func,
  isBulk: PropTypes.bool,
  refetchOrderDetails: PropTypes.func,
  consigneeId: PropTypes.number,
  refetchRfqList: PropTypes.func,
  customIds: PropTypes.arrayOf(PropTypes.string),
  refetchConsolidatedList: PropTypes.func,
  isConsole: PropTypes.bool,
  modeSelectionConsole: PropTypes.arrayOf(PropTypes.string),
  customIdsBooking: PropTypes.arrayOf(PropTypes.string),
  bulkVitroRefIds: PropTypes.arrayOf(PropTypes.string),
};
BuyerBooking.defaultProps = {
  itemsData: {},
  columns: [],
  toggleViewDetailsModal: () => {},
  isBulk: false,
  refetchOrderDetails: () => {},
  consigneeId: null,
  refetchRfqList: () => {},
  customIds: [],
  refetchConsolidatedList: () => {},
  isConsole: false,
  modeSelectionConsole: '',
  customIdsBooking: [],
  bulkVitroRefIds: [],
};
